<template>
  <div class="col s4 offset-s4 full-height-percent">
    <div class="row app-body-height">
      <div class="col s12 left-align">
        <div class="row no-padding">
          <h5 class="loading-header">{{ $t('views.login.loadingscreenheader') }}</h5>
        </div>
        <div class="row no-padding">
          <ul class="collection collection-clouds">

            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ $t('views.login.possobjectcodes')}}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="!loaded.possObjectsCode">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="loaded.possObjectsCode">done</i>
                </a>
              </div>
            </li>

            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ $t('views.login.presets')}}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="!loaded.presets">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="loaded.presets">done</i>
                </a>
              </div>
            </li>

            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ $t('views.login.complexes')}}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="!loaded.complexes">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="loaded.complexes">done</i>
                </a>
              </div>
            </li>

            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ $t('views.login.railobjects')}}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="!loaded.railobjects">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="loaded.railobjects">done</i>
                </a>
              </div>
            </li>

            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ $t('views.login.departments')}}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="!loaded.departments">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="loaded.departments">done</i>
                </a>
              </div>
            </li>

            <li class="collection-item collection-item-clouds grey-color">
              <div class="progression-text">{{ $t('views.login.regions')}}
                <a
                  href="#!"
                  class="secondary-content">
                  <i
                    class="material-icons blue-color"
                    v-show="!loaded.regions">
                    cloud_download
                    <div class="progress progression-cloud">
                      <div class="indeterminate blue-color-background"/>
                    </div>
                  </i>
                  <i
                    class="material-icons blue-color"
                    v-show="loaded.regions">done</i>
                </a>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
    <div class="row app-footer-height app-footer-margins">
      <div class="col s6 left-align no-padding"/>
      <div class="col s6 right-align no-padding">
        <p class="no-margin grey-color">{{ this.$parent.versionNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../router'

import RailObjectsApi from '../../services/api/RailObjectsApi'
import DepartmentsApi from '../../services/api/DepartmentsApi'
import RegionsApi from '../../services/api/RegionsApi'
import ComplexesApi from '../../services/api/ComplexesApi'
import PossObjectCodesApi from '../../services/api/PossObjectCodesApi'
import DashboardPresetsApi from '../../services/api/DashboardPresetsApi'

import DepartmentService from '../../services/DepartmentService'
import RegionService from '../../services/RegionService'
import ComplexService from '../../services/ComplexService'
import RailObjectService from '../../services/RailObjectService'
import PossObjectCodeService from '../../services/PossObjectCodeService'
import DashboardPresetService from '../../services/DashboardPresetService'
import {MaintenanceNotificationSingle} from '../../services/MaintenanceNotificationService'
import AuthenticationService from '../../services/AuthenticationService'

export default {
  data () {
    return {
      // Objects to be loaded before application start
      loaded: {
        railobjects: false,
        possObjectsCode: false,
        regions: false,
        departments: false,
        complexes: false,
        presets: false
      },
      currentUser: AuthenticationService.getUser()
    }
  },
  created () {
    document.addEventListener('backbutton', this.yourCallBackFunction, false)
  },
  beforeDestroy () {
    document.removeEventListener('backbutton', this.yourCallBackFunction)
  },
  methods: {
    loadData: function () {
      this.$eventHub.$emit('loadingpossdata', true)
      this.$eventHub.$emit('shownavbar', false)

      this.headerText = 'views.login.loading'
      setTimeout(() => {
        var railObjectsPromise = Promise.all([RailObjectsApi.getRailObjects(), RailObjectsApi.getRailObjectChildren()]) // .then((response) => { this.loaded.railobjects = true; })
        railObjectsPromise.type = 'railObjects'
        var possObjectsCodePromise = PossObjectCodesApi.getPossObjectCodes() // .then(() => { this.loaded.possObjectsCodes = true })
        possObjectsCodePromise.type = 'possObjectsCode'
        var regionsPromise = RegionsApi.getRegions() // .then(() => { this.loaded.regions = true })
        regionsPromise.type = 'regions'
        var departmentsPromise = DepartmentsApi.getDepartments() // .then(() => { this.loaded.departments = true })
        departmentsPromise.type = 'departments'
        var complexesPromise = ComplexesApi.getComplexes() // .then(() => { this.loaded.complexes = true })
        complexesPromise.type = 'complexes'
        var dashboardPresetPromise = DashboardPresetsApi.getDashboardPresets()
        dashboardPresetPromise.type = 'presets'

        var promises = [
          railObjectsPromise,
          possObjectsCodePromise,
          regionsPromise,
          departmentsPromise,
          complexesPromise,
          dashboardPresetPromise
        ]

        promises.forEach((p) => {
          p.then(() => {
            switch (p.type) {
              case 'railObjects':
                this.loaded.railobjects = true
                break
              case 'possObjectsCode':
                this.loaded.possObjectsCode = true
                break
              case 'regions':
                this.loaded.regions = true
                break
              case 'departments':
                this.loaded.departments = true
                break
              case 'complexes':
                this.loaded.complexes = true
                break
              case 'presets':
                this.loaded.presets = true
                break
            }
          })
        })

        Promise.all(promises).then((values) => {
          var railObjects = values[0][0].data
          var railObjectChildren = values[0][1].data
          var possObjectCode = values[1].data
          var regions = values[2].data
          var departments = values[3].data
          var complexes = values[4].data
          var dashboardPresets = values[5].data

          RailObjectService.setRailObjects(railObjects)
          RailObjectService.setRailObjectChildren(railObjectChildren)
          DepartmentService.setDepartments(departments)
          RegionService.setRegions(regions)
          ComplexService.setComplexes(complexes)
          PossObjectCodeService.setPossObectCodes(possObjectCode)
          DashboardPresetService.setDashboardPresets(dashboardPresets)

          setTimeout(() => {
            this.$eventHub.$emit('authenticated', true)
            this.$eventHub.$emit('shownavbar', true)
            this.$eventHub.$emit('loadingpossdata', false)
            // Store current route with parameters, so we can use it when identity server login is completed
            var pendingRoute = localStorage.getItem('pendingRoute')
            localStorage.removeItem('pendingRoute')
            var returnPath = pendingRoute || localStorage.getItem('lastRoute')

            let syncContext = this
            MaintenanceNotificationSingle.startMaintenanceNotificationMonitoring((message) => {
              syncContext.$root.$notify({
                group: 'maintenance',
                type: 'warn',
                title: 'x',
                text: syncContext.$root.$t(message),
                duration: 999999999,
                speed: 1000
              })
            })
            if (returnPath !== null && returnPath !== undefined && returnPath !== '') {
              // We redirect to the users dashboard when a default dashboard is configured for the user
              if (
                returnPath === '/' &&
                this.currentUser &&
                this.currentUser.DashboardId &&
                this.currentUser.DashboardId !== 'undefined'
              ) {
                returnPath = `/dashboard${this.currentUser.DashboardId}`
              }
              router.push(returnPath)
            } else {
              router.push({name: 'Dashboard'})
            }
          }, 0)
        }).catch((reason) => {
          this.$eventHub.$emit('shownavbar', false)
          this.$eventHub.$emit('authenticated', false)
          this.$eventHub.$emit('loadingpossdata', false)
          router.push('/login/loginscreen')
        })
      }, 0)
    }
  },
  beforeMount () {
    // var lang = localStorage.getItem('locale')
    // Translation.setLanguage(lang).then((language) => {
    //   this.locale = language
    // })
    if (!this.$parent.preventLogin) {
      this.loadData()
    } else {
      router.push('/login/error')
    }
  }
}
</script>

<style scoped>
  .collection-item-clouds {
    padding-left: 0px;
    padding-right: 0px;
    border: 0px;
  }

  .collection-clouds {
    padding-left: 53px;
    padding-right: 49px;
    border: 0px;
  }

  .progression-cloud {
    background-color: white;
    height: 2px;
  }

  .progression-text {
    margin-left: 45px;
    position: relative;right: 2em;
  }

  .loading-header {
    color: #56CCF2;
    padding-top: 144px;
    padding-left: 53px;
    padding-right: 49px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/_LoadData.vue